import { render, staticRenderFns } from "./ORepeatingCards.vue?vue&type=template&id=a2ba704e&scoped=true&"
import script from "./ORepeatingCards.vue?vue&type=script&lang=js&"
export * from "./ORepeatingCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ba704e",
  null
  
)

export default component.exports